export const NEW_REFERRAL_RECEIVED = 'NEW_REFERRAL_RECEIVED';
export const NEW_REFERRALS_ACKNOWLEDGED = 'NEW_REFERRALS_ACKNOWLEDGED';

export function newReferralReceived(referralId) {
  return {
    type: NEW_REFERRAL_RECEIVED,
    referralId,
    receivedAt: Date.now(),
  };
}

export function newReferralsAcknowledged() {
  return {
    type: NEW_REFERRALS_ACKNOWLEDGED,
  };
}
